<template>
  <div class="create_class-root page-root-region five-application-region-form">
    <div class="main-content-wrap">
      <yioks-page-nav @backBtnHandle="backComfim = true" class="nav-wrap">
        <p class="title">
          {{ isEdit ? "编辑培训班开班申请" : "添加培训班开班申请" }}
        </p>
        <!-- <div class="nav-right" slot="right">
          <p>开班成功后，系统将自动创建学员帐号，并分组~</p>
        </div> -->
      </yioks-page-nav>

      <div class="content-wrap">
        <vue-scroll :ops="vuescrollOpt">
          <div class="form-wrapper">
            <el-form
              ref="regionForm"
              size="medium"
              :model="regionForm"
              :rules="regionFormRules"
              label-width="125px"
              style="position: relative;margin-top: 20px;"
            >
              <div class="error-tips">
                * 根据中国足协五人制足球教练员培训要求，初级必须提前35天提交申请，L1级必须提前50天提交申请。
              </div>
              <el-row :gutter="0">
                <el-col :span="12">
                  <el-form-item prop="class_start" label="培训日期" class="">
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      @change="changeState"
                      value-format="timestamp"
                      format="yyyy 年 MM 月 dd 日"
                      :picker-options="reportStartOpt"
                      v-model="regionForm.class_start"
                      placeholder="请选择开始日期"
                      type="date"
                      class="w190"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="12" class="flex-wrapper">
                  <div class="line-wrapper">————</div>
                  <el-form-item
                    prop="class_end"
                    label=""
                    label-width="0"
                    class=""
                  >
                    <el-date-picker
                      :editable="false"
                      :clearable="false"
                      value-format="timestamp"
                      format="yyyy 年 MM 月 dd 日"
                      :picker-options="reportEndOpt"
                      v-model="regionForm.class_end"
                      placeholder="请选择开始日期"
                      type="date"
                      class="w190"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="期数" prop="periods" class>
                <span class="">第</span>
                <el-input-number
                  v-model="regionForm.periods"
                  controls-position="right"
                  class="periods"
                  :min="1"
                ></el-input-number>
                <span class="">期</span>
                <span style="color:#ff0000;margin-left:20px;font-size:15px" v-if="regionForm.class_level === 'L1'"> * 培训班期数需询问中国足协</span>
              </el-form-item>
              <el-form-item label="培训班级别" prop="class_level" class>
                <el-select
                  v-model="regionForm.class_level"
                  class="input-w260"
                  disabled
                  placeholder="请选择培训班级别"
                >
                  <el-option
                    v-for="item in level_select_list"
                    :key="item.value"
                    :label="item.key"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="训练场地" prop="training_address">
                <el-input
                  v-model.trim="regionForm.training_address"
                  placeholder="请填写训练场地"
                ></el-input>
              </el-form-item>

              <el-form-item label="理论课场地" prop="theory_address">
                <el-input
                  v-model.trim="regionForm.theory_address"
                  placeholder="请填写训练场地"
                ></el-input>
              </el-form-item>

              <el-form-item label="主讲师" prop="teacher_off_id">
                <el-select
                  v-model="regionForm.teacher_off_id"
                  :default-first-option="true"
                  clearable
                  filterable
                >
                  <el-option label="足协指派" value=""></el-option>
                  <el-option
                    v-for="lecturer in lecturerList"
                    :key="lecturer.user_id"
                    :label="`${lecturer.teacher_name_unit}`"
                    :value="lecturer.user_id"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="助理讲师"
                class="inline-item-wrap form-item-nomb"
              >
                <el-form-item
                  v-for="(item, index) in regionForm.assistantLecturer"
                  label-width="0px"
                  :prop="'assistantLecturer.' + index + '.val'"
                  :rules="{
                    validator: (rule, val, callback) => {
                      return validateAssLec(rule, val, callback, index);
                    },
                    trigger: `change`,
                  }"
                  class="form-input-item input-item-hasmb"
                  :key="item.key"
                >
                  <el-select
                    v-model="item.val"
                    :default-first-option="true"
                    filterable
                  >
                    <el-option :label="item.placeholder" value=""></el-option>
                    <el-option
                      v-for="lecturer in assistantLecturerList"
                      :key="lecturer.user_id"
                      :label="`${lecturer.teacher_name_unit}`"
                      :value="lecturer.user_id"
                    ></el-option>
                  </el-select>
                  <i
                    v-if="index > 0"
                    class="input-icon el-icon-close"
                    @click="removeHost(item, 'assistantLecturer')"
                  ></i>
                </el-form-item>
                <el-button
                  type="primary"
                  size="medium"
                  icon="el-icon-plus"
                  @click="
                    addHost(
                      'assistantLecturer',
                      {
                        val: '',
                        key: Date.now(),
                        placeholder: '(空)',
                        isTestErr: null,
                        errMsg: '',
                      },
                      assistantLecturerList.length - 1
                    )
                  "
                  :disabled="
                    regionForm.assistantLecturer.length >
                    assistantLecturerList.length - 1
                  "
                  class="form-item-btn button-hasmb"
                  >更多</el-button
                >
              </el-form-item>

              <el-form-item label="讲师入住酒店名称" prop="teacher_accommodation_hotel">
                <el-input
                  v-model.trim="regionForm.teacher_accommodation_hotel"
                  placeholder="请填写酒店名称"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="讲师入住酒店地址"
                prop="teacher_accommodation_address"
              >
                <el-input
                  v-model.trim="regionForm.teacher_accommodation_address"
                  placeholder="请填写酒店地址"
                ></el-input>
              </el-form-item>

              <el-form-item label="讲师入住酒店电话" prop="teacher_hotel_phone">
                <el-input
                  v-model.trim="regionForm.teacher_hotel_phone"
                  placeholder="请填写酒店电话"
                ></el-input>
              </el-form-item>

              <el-form-item label="培训班协调员" prop="saveContact">
                <el-button type="primary" @click="ifContactDiaShow = true"
                  >添加培训班协调员</el-button
                >
                <span :class="['tip', testContact ? 'yes' : 'no']">{{
                  testContact ? "培训班协调员添加成功" : "培训班协调员未添加"
                }}</span>
              </el-form-item>

              <el-form-item label="备注" prop="remark">
                <el-input
                  v-model="regionForm.remark"
                  type="textarea"
                  :rows="4"
                  placeholder="请填写备注信息"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </vue-scroll>
      </div>
      <div class="post-btn" v-if="['sysFive', 'supFive'].includes(localUserInfo.member_type)">
        <el-button type="primary" @click="regionAction('audit')"
          >编辑申请</el-button
        >
      </div>
      <div class="post-btn" v-if="['orgFive'].includes(localUserInfo.member_type)">
        <el-button type="primary" @click="regionAction('audit')"
        >提交申请</el-button
        >
        <el-button @click="regionAction('edit')">暂时保存</el-button>
      </div>

      <el-dialog
        @open="contactDiaOpen"
        :visible.sync="ifContactDiaShow"
        :close-on-click-modal="false"
        top="13vh"
        width="855px"
        class="yi-dialog-root scroll-dialog"
      >
        <div class="slot-dialog-header" slot="title">
          <span class="title">添加培训班协调员</span>
          <!-- <span class="prompt">注：学员手机号将作为登录培训系统的初始密码~</span> -->
        </div>
        <div class="dialog-content contact-dia-content">
          <vue-scroll :ops="disScrollOpt">
            <div class="dia-scroll-content">
              <el-form
                :model="contactData"
                ref="contactDialogForm"
                label-width="70px"
                size="medium"
                class="dia-form"
              >
                <div
                  class="form-oneline-wrap clearfix"
                  v-for="(contact, index) in contactData.contactInfoList"
                  :key="contact.id"
                >
                  <el-form-item
                    label="姓名"
                    :prop="'contactInfoList.' + index + '.name'"
                    :rules="{
                      required: true,
                      message: `不能为空`,
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-name-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人姓名"
                      v-model="contact.name"
                      class="dia-input-w100"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="电话"
                    :prop="'contactInfoList.' + index + '.mobile_phone'"
                    :rules="{
                      required: true,
                      validator: (rule, value, callback) => {
                        validatePhone(rule, value, callback, false);
                      },
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-phone-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人手机号"
                      v-model="contact.mobile_phone"
                      class="dia-input-w100"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="邮箱"
                    :prop="'contactInfoList.' + index + '.email'"
                    :rules="{
                      required: false,
                      validator: (rule, value, callback) => {
                        validateEmail(rule, value, callback, false);
                      },
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-email-wrap"
                  >
                    <el-input
                      placeholder="请输入联系人邮箱"
                      v-model="contact.email"
                      class="dia-input-w100"
                    ></el-input>
                  </el-form-item>
                  <el-form-item
                    label="工作单位"
                    :prop="'contactInfoList.' + index + '.work'"
                    :rules="{
                      required: false,
                      validator: (rule, value, callback) => {
                        validateStrLength(rule, value, callback, false);
                      },
                      trigger: `blur`,
                    }"
                    class="dia-input-wrap contact-email-wrap"
                  >
                    <el-input
                      placeholder="请填写工作单位"
                      v-model="contact.work"
                      class="dia-input-w100"
                    ></el-input>
                  </el-form-item>
                  <el-button
                    class="form-oneline-btn"
                    size="medium"
                    type="danger"
                    v-if="index > 0"
                    @click="delContact(contact)"
                    >删除</el-button
                  >
                  <el-button
                    v-else
                    class="form-oneline-btn"
                    size="medium"
                    type="primary"
                    @click="addContact"
                    >添加</el-button
                  >
                </div>
              </el-form>
              <div class="dia-center-btn">
                <!-- <el-button class="dia-add-btn" type="primary" @click="addContact">添加</el-button> -->
              </div>
            </div>
          </vue-scroll>
        </div>
        <div class="footer-btn" slot="footer">
          <div class="btns">
            <div class="btn save" @click="saveContactList">保存</div>
            <div class="btn cancel" @click="ifContactDiaShow = false">取消</div>
          </div>
        </div>
      </el-dialog>

      <yioks-tips
        :showTips="isShowConfirmTips"
        :tips="tipsInfo"
        :loading="confirmLoading"
        @hideTips="hideConfirmTips"
      ></yioks-tips>
      <yioks-tips
        :showTips="backComfim"
        tips="确认退出当前操作吗？"
        @hideTips="handleBackConfirm"
      ></yioks-tips>
    </div>
  </div>
</template>

<script>
import ops from "@/assets/js/vuescrollOption";
import createScrollOpt from "@/assets/js/vuescrollOption";
import { classLevelListFive } from "@/assets/js/select";
import { storageData } from "@/assets/js/storage";
import {
  getLecturers,
  getFiveClassApplicationConnection,
  getLecturersForFive,
  getFiveClassApplicationPeriod,
  postFiveClassApplicationData,
  getFiveClassApplicationData,
  putFiveClassApplicationData,
} from "@/api/agency/agency";
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import commonFun from "@/assets/js/yioks";
const {
  mobile_phone,
  idCard_number,
  email,
  checkWork,
  checkHkongMacao,
  checkTaiwOld,
  checkPassport,
  checkHMT,
} = commonFun;

export default {
  components: {
    "yioks-page-nav": () => import("@/components/PageNav/PageNav"),

    "yioks-tips": () => import("@/components/Tips/Dialog"),
  },
  data() {
    const validateAssLec = (rule, value, callback, i) => {
      if (this.regionForm.assistantLecturer[i].isTestErr) {
        callback(new Error(this.regionForm.assistantLecturer[i].errMsg));
      } else {
        this.$set(this.regionForm.assistantLecturer[i], "isTestErr", false);
        this.$set(this.regionForm.assistantLecturer[i], "errMsg", "");
        callback();
      }
    };
    const validatePhone = (rule, value, callback, bool, index) => {
      if (mobile_phone(value)) {
        // 还需要显示后台的校验错误信息
        if (bool) {
          // 如果后台校验手机号有问题
          if (this.dataTestResults[index].mobile_phone.bool) {
            callback(new Error(this.dataTestResults[index].mobile_phone.msg));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入有效的11位手机号"));
      }
    };
    const validateEmail = (rule, value, callback, bool, index) => {
      if (value == "") {
        callback();
      }
      if (email(value)) {
        if (bool) {
          // 如果后台校验手机号有问题
          if (dataTestResults[index].email.bool) {
            callback(new Error(dataTestResults[index].email.msg));
          } else {
            callback();
          }
        } else {
          callback();
        }
      } else {
        callback(new Error("请输入格式正确的邮箱"));
      }
    };
    const validateStrLength = (rule, value, callback, bool, index) => {
      if (value == "") {
        callback();
      } else {
        const strLen = String(value).length;
        if (strLen > 20) {
          callback(new Error("输入工作单位长度不应超过20"));
        } else {
          callback();
        }
      }
      //  else {
      //   callback(new Error("请输入格式正确的邮箱"));
      // }
    };
    return {
      ops: ops(),
      localUserInfo: storageData.getUserInfo(),
      vuescrollOpt: createScrollOpt(),
      disScrollOpt: createScrollOpt(true),
      validateAssLec,
      validateStrLength,
      validatePhone,
      validateEmail,
      regionForm: {
        class_start: "",
        class_end: "",
        periods: 1,
        class_level:this.$route.query.class_level,
        training_address: "",
        theory_address: "",
        teacher_off_id: "",
        assistantLecturer: [
          {
            val: "",
            key: Date.now(),
            placeholder: "(空)",
            isTestErr: null,
            errMsg: "",
          },
        ],
        teacher_accommodation_hotel: "",
        teacher_accommodation_address: "",
        teacher_hotel_phone: "",
        saveContact: [], //  联系人
        remark: "",
      },

      lecturerList: [], // 讲师列表
      lecturerStore: [], // 讲师列表  -- 暂时不要了
      assistantLecturerList: [], // 助理讲师列表
      assistantStore: [], // 助理讲师列表  -- 暂时不要了

      //  联系人
      ifContactDiaShow: false,
      contactData: {
        contactInfoList: [
          { name: "", mobile_phone: "", email: "", work: "", id: 1 },
        ],
      },
      testContact: false, // 联系人存在标记

      isShowConfirmTips: false,
      confirmLoading: false,
      tipsInfo: "",
      tipsStatus: "", // 标记按钮状态，提交，暂时保存
      backComfim: false,
    };
  },

  watch: {
    testContact: {
      handler: function (val) {
        this.$refs["regionForm"].validateField("saveContact");
      },
    },
  },

  computed: {
    
    isEdit() {
      // 标记编辑状态
      const { isEdit } = this.$route.query;
      if (isEdit == "1") {
        return true;
      } else {
        return false;
      }
    },
    application_id() {
      // 标记编辑状态
      const { application_id } = this.$route.query;
      return application_id;
    },
//    class_level(){
//      if(!this.isEdit){
//        const { class_level } = this.$route.query;
//        console.log(class_level)
//        this.regionForm.class_level = class_level;
//        return class_level;
//      }
//
//    },
    reportStartOpt() {
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: (time) => {
//          return (
//            new Date(time).getTime() + 1000 * 3600 * 24 < new Date().getTime()
//          )
            if(this.isEdit) {
              const { status,class_level } = this.regionForm
              if(status === 'edit') {
                let day = class_level==='early'?35:50
                return time < new Date().getTime() + 1000 * 3600 * 24 * day
              } else {
                return time < new Date().getTime()
              }
            } else {
              const { class_level } = this.regionForm
              let day = class_level==='early'?35:50
              return time < new Date().getTime() + 1000 * 3600 * 24 * day
            }
        },
      };
    },
    reportEndOpt() {
//      regionForm.class_start
      const  { class_start } = this.regionForm;
      return {
        // 这里如果不使用箭头函数则无法正确访问到 this
        disabledDate: (time) => {
          if(class_start) {
            return time < class_start
          } else {
            return (
              new Date(time).getTime() + 1000 * 3600 * 24 < new Date().getTime()
            );
          }
          
        },
      };
    },

    regionFormRules() {
      return {
        class_start: [requiredItem("培训开始日期")],
        class_end: [requiredItem("培训结束日期")],
        periods: [requiredItem("期数")],
        class_level: [requiredItem("培训班级别")],
        training_address: [requiredItem("培训班级别")],
        theory_address: [requiredItem("理论课场地")],
      };
    },

    level_select_list() {
      return classLevelListFive;
    },
  },

  created() {
    // 设置默认联系人
    if (!this.isEdit) {
      // 获取讲师列表
      this.loadLectureList();
      this.getClassLinks();
    }
    
  },

  mounted() {
    if (this.isEdit) {
      this.loadApplicationDefaultInfo();
    }
  },

  methods: {
    goBack() {
      if (this.backUrl) this.$router.push(this.backUrl);
      this.$router.back();
    },

    // 获取讲师，助理讲师列表
    loadLectureList() {
      const paramsData = {
        class_level: this.regionForm.class_level,
      };
      getLecturersForFive(paramsData)
        .then(({ data }) => {
          if (data.status === 0) {
            const { teacher_assistant_list, teacher_list } = data.result;
            this.lecturerList = teacher_list;
            this.assistantLecturerList = teacher_assistant_list;
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },

    lecturerFilter(val) {
      this.lecturerList = JSON.parse(JSON.stringify(this.lecturerStore));
      if (val) {
        this.lecturerList = this.lecturerList.filter((item) => {
          return item.teacher_name_unit.includes(val);
        });
        if (this.lecturerList.length === 1) {
          this.regionForm.teacher_off_id = this.lecturerList[0].user_id;
        }
      } else {
        this.regionForm.teacher_off_id = "";
      }
    },

    changeState(val) {
      if (val) {
        const paramsData = {
          class_start: val,
          class_level: this.regionForm.class_level,
        };
        getFiveClassApplicationPeriod(paramsData).then(({ data }) => {
          if (Number(data.status) === 0) {
            this.$set(this.regionForm, "periods", data.result.periods);
          }
        });
      }
    },

    removeHost(item, dataKey) {
      const index = this.regionForm[dataKey].indexOf(item);
      if (index !== -1) {
        this.regionForm[dataKey].splice(index, 1);
      }
    },
    addHost(dataKey, itemData, length = 1) {
      if (this.regionForm[dataKey].length > length) return;
      this.regionForm[dataKey].push(itemData);
    },

    // 添加联系人弹窗 beforeOpen
    contactDiaOpen() {
      this.$nextTick(() => {
        this.$refs["contactDialogForm"].clearValidate();
      });
      const regionForm = JSON.parse(JSON.stringify(this.regionForm));
      this.$set(this.contactData, "contactInfoList", regionForm.saveContact);
    },
    // 删除联系人
    delContact(item) {
      const index = this.contactData.contactInfoList.indexOf(item);
      index !== -1 && this.contactData.contactInfoList.splice(index, 1);
    },
    // 添加联系人
    addContact() {
      if (this.contactData.contactInfoList.length > 8) return;
      this.contactData.contactInfoList.push({
        name: "",
        mobile_phone: "",
        email: "",
        id: this.contactData.contactInfoList.length + 1,
      });
    },

    // 保存联系人
    saveContactList() {
      this.$refs["contactDialogForm"].validate((valid) => {
        const contactData = JSON.parse(JSON.stringify(this.contactData));
        if (valid) {
          this.$set(this.regionForm, "saveContact", [
            ...contactData.contactInfoList,
          ]);
          this.ifContactDiaShow = false;
          this.testContact = true;
        } else {
          // this.testContact = false
          return false;
        }
      });
    },

    // 获取默认联系人列表
    getClassLinks() {
      getFiveClassApplicationConnection()
        .then(({ data }) => {
          if (data.status === 0) {
            const {
              result: { linkman, venueData },
            } = data;
            if (linkman.length > 0) {
              this.contactData.contactInfoList = linkman.map(
                ({ email, mobile_phone, name, work, tc_id }, i) => ({
                  name,
                  email,
                  mobile_phone: mobile_phone,
                  work,
                  id: i + 1,
                })
              );
              this.testContact = true;
            } else {
              this.testContact = false;
            }

            if (venueData && venueData.length) {
              this.selectAddress = venueData.map((item) => ({
                label: item.undertake_unit,
                value: item.venue_uuid,
              }));
            } else {
              this.selectAddress = [];
            }
            this.regionForm.saveContact = JSON.parse(
              JSON.stringify(this.contactData.contactInfoList)
            );
            // 有了默认联系人的话，将联系人的校验结果为true，反之为false
          } else {
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },

    // 页面按钮操作
    regionAction(actionStatus) {
      this.tipsStatus = actionStatus; // 记录操作状态
      if (actionStatus == "audit" ||actionStatus == "edit" ) {
        // 提交申请
        this.$refs["regionForm"].validate((valid) => {
          if (valid) {
            if (!this.testContact) return;
            this.showTips(actionStatus);
          }
        });
      }  else {
        console.error("随便了，错误操作码：", actionStatus);
      }
    },
    showTips(actionStatus) {
      if (actionStatus == "edit") {
        this.tipsInfo = "确认暂时保存吗？";
      } else if (actionStatus == "audit") {
        this.tipsInfo = "确认提交申请吗？";
      } else {
        this.tipsInfo = "确认当前操作吗？";
      }
      this.isShowConfirmTips = true;
    },

    // 提交表单方法
    submitFormData() {
      const { assistantLecturer, saveContact, ...otherInfo } = this.regionForm;
      const assistantLecturerIdList = assistantLecturer.map((item) => {
        return item.val;
      });
      const postData = {
        ...otherInfo,
        status: this.tipsStatus,
        teacher_ids: assistantLecturerIdList.join(","),
        class_the_application_linkman: JSON.stringify(saveContact),
      };
      this.confirmLoading = true;
      const requestName = this.isEdit ? putFiveClassApplicationData : postFiveClassApplicationData
      requestName(postData)
        .then(({ data }) => {
          this.confirmLoading = false;
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          this.$message.success("信息保存成功！");
          this.$router.go(-1);
        })
        .catch((err) => {
          this.confirmLoading = false;
          console.error("err", err);
        });
    },

    hideConfirmTips(ok, flag) {
      if (flag) {
        this.submitFormData();
      } else {
        this.isShowConfirmTips = false;
      }
    },

    // 后退操作
    handleBackConfirm(ok, flag) {
      if (flag) {
        this.backComfim = false;
        this.$router.go(-1);
      } else {
        this.backComfim = false;
      }
    },

    // 设置默认信息
    loadApplicationDefaultInfo() {
      const params = {
        application_id: this.application_id,
      };
      getFiveClassApplicationData(params)
        .then(({ data }) => {
          if (data.status !== 0) {
            this.$message.error(data.msg);
            return;
          }
          const { application, linkMan } = data.result;
          this.regionForm.class_level = application.class_level;
          if (linkMan.length > 0) {
            this.contactData.contactInfoList = linkMan.map(
              ({ email, mobile_phone, name, work, tc_id }, i) => ({
                name,
                email,
                mobile_phone: mobile_phone,
                work,
                id: i + 1,
              })
            );
            this.testContact = true;
          } else {
            this.testContact = false;
          }
          this.regionForm.saveContact = JSON.parse(
            JSON.stringify(this.contactData.contactInfoList)
          );
          this.regionForm = Object.assign({}, this.regionForm, application);
          this.regionForm.assistantLecturer = this.$yioks
            .nullToStr(application.teacher_ids)
            .split(",")
            .map((item, index) => {
              return {
                val: item === "" ? "" : Number(item),
                key: index,
                isTestErr: null,
                placeholder: "(空)",
              };
            });
          if(this.regionForm.teacher_off_id === 0) this.regionForm.teacher_off_id = '';
          // 有级别了 获取一下讲师 列表
          this.loadLectureList();
        })
        .catch((err) => {
          console.error("err", err);
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/class'
@import '~@/assets/css/variable'
@import '~@/assets/css/defaultPage'
@import '~@/assets/css/yioksPage'
.w_100
  width 100%
.form-wrapper
  width calc(80%)
  margin 0 auto
  padding-right 120px
  box-sizing border-box
.five-application-region-form
  /deep/.el-form-item__label
    color #fff
  .periods
    margin 0 10px
.ml120
  margin-left 120px
.line-wrapper
  width 120px
  height 30px
  display flex
  align-items center
  justify-content center
  padding-left: 20px
.flex-wrapper
  display flex
.inline-item-wrap
  .form-input-item
    float left
    margin-right 10px
  .input-icon
    cursor pointer
    position absolute
    top 0
    right 0
    padding 2px
    border-radius 50%
    color $color_white
    font-size 12px
    z-index 111
    transform translate(39%, -39%)
    background-color $color_suc
  .form-item-btn
    float left
.form-item-nomb
  margin-bottom 0
  .input-item-hasmb
    margin-bottom 22px
  .button-hasmb
    margin-bottom 15px
.yes
  color $color_suc
.no
  color $color_err
.dialog-content
  height 500px
  .el-form-item__error
    width 200px
    font-size 12px
  .dia-form
    .form-oneline-wrap
      border-bottom 1px solid #ccc
      padding-top 20px
      position relative
      .num
        position absolute
        top 28px
        left 10px
      .dia-input-wrap
        float left
        margin-bottom 20px
        .el-form-item__label
          font-size 14px !important
      .dia-input-w180
        width 180px
      .dia-input-w160
        width 160px
      .dia-input-w100
        width 100px
      .number-input
        width 170px
      .name-input
        width 120px
      .phone-input
        width 130px
      .form-oneline-btn
        float left
        margin-left 15px
      .stu-opt
        float left
        width 70px
        height 36px
        margin 0
        font-size 26px
        display flex
        justify-content space-around
        align-items center
        .opt-icon
          cursor pointer
        .disabled
          color $color_info
        .add
          color $color_suc
        .remove
          color $color_err
  .dia-center-btn
    display block
    padding 10px
    text-align center
.contact-dia-content
  height 380px
.slot-dialog-header
  display flex
  align-items center
  line-height 1
  padding-bottom 10px
  font-size 20px
  border-bottom 1px solid $color_text_secondary
  color $color_text_primary
  position relative
.footer-btn
  .btns
    display flex
    justify-content center
    color $color_white
    .btn
      padding 10px 25px
      margin 0 10px
      border-radius 4px
      cursor pointer
      user-select none
    .save
      background-color $color_suc
    .cancel
      background-color $color_err
.dia-form
  /deep/.el-form-item__label
    color #606266
.tip
  margin-left 10px
  
.error-tips
  color $color_err !important
  font-size: 13px;
  position: absolute;
  top: -20px;
  left: 0;
  width: 750px;
  padding-left: 125px;
  
.w190
  width 190px !important
</style>
